module.exports = __webpack_public_path__ + "static/img/detail_popup.13df395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/servitor/circus/popup/detail_popup.png
// module id = 9Rms
// module chunks = 7